import { borrowersAPI } from "services/swagger-api";
import { MainBorrowerProfilingState } from "../../types";
import { MainBorrowerProfilingSyncActions } from "../types";

export const initBorrowerProfilingProcess = async (
  borrowerProjectId: string,
  actions: MainBorrowerProfilingSyncActions,
  getState: () => MainBorrowerProfilingState,
): Promise<void> => {
  try {
    actions.setLoading(true)
    actions.setError(null)
    const response = await borrowersAPI.getBorrowerProjectById({ borrowerProjectId })
    if (response) {
      actions.setBorrowerProjectId(borrowerProjectId)
      actions.setBorrowerProjectInfos(response)
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue')
  } finally {
    actions.setLoading(false)
  }
}
